export const InviteFormFields = {
  staff: 'staff',
} as const;

export const InviteFormFieldsForStaff = {
  email: 'email',
  businessRole: 'businessRole',
} as const;
